module.exports = __webpack_public_path__ + "img/pic.8b11d0b6.png";